import styled from "styled-components";
import { baseColors } from "../../../../../themes/definitions/casino888/base-colors";

export const HeaderBalanceDefaultBox = styled.div`
    color: ${baseColors.white};
    ${({theme}) => theme.font.presets.medium};
    line-height: 1;
`;